import controller from './order-detail.controller';
import template from './order-detail.view.html';

let OrderDetailComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default OrderDetailComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/orders/order-detail/order-detail.component.js
 **/